import { Colors } from '../../../theme/colors';
import { StatusBadge } from '../status-badge/status-badge.component';
import { Unknown } from '../icons/Unknown.icon';
import { userStatusToColor } from './user-status-to-color.map';
import { userStatusToIcon } from './user-status-to-icon.map';
import { userStatusToLabel } from './user-status-to-label.map';
import { BadgeUserStatus } from './badge-user-status';

export interface UserStatusBadgeProps {
  status?: string;
  align?: 'left' | 'center' | 'right';
  fontSize?: string;
  showTooltip?: boolean;
  condensed?: boolean;
}

export const UserStatusBadge = ({
  status,
  align,
  fontSize = '13px',
  showTooltip = true,
  condensed
}: UserStatusBadgeProps) => {
  // Table cells must render an element, so an absent status collapses to nothing
  if (!status) {
    return <></>;
  }

  const knownStatus = status as BadgeUserStatus;
  const condensedProps = condensed ? ({ collapse: 'wrap-sides', desktopHeight: '24px' } as const) : undefined;

  return (
    <StatusBadge
      label={userStatusToLabel[knownStatus] ?? status}
      color={userStatusToColor[knownStatus] ?? Colors.bookedScannedInProgressGray}
      Icon={userStatusToIcon[knownStatus] ?? Unknown}
      iconSize="18px"
      cornerRounding="med"
      fontSize={fontSize}
      showTooltip={showTooltip}
      align={align}
      capitalize
      {...condensedProps}
    />
  );
};
